export const incidents = [
  {
    path: '/event-log',
    name: 'Incidents',
    component: () => import('./Incidents.vue'),
    beforeEnter: (to, from, next) => {
      // Bloqueo temporal
      next(false) // Cancela la navegación
      // O redirigir, por ejemplo:
      // next('/')
    },
    meta: {
      rule: 'UNITS',
      autoRequired: true,
      title: 'incidents.event',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'incidents.event',
          disabled: true,
          href: '#/event-log'
        }
      ]
    }
  },
  {
    path: '/detail-incident/:id',
    name: 'DetailsIncidents',
    component: () => import('./DetailsIncidents.vue'),
    meta: {
      rule: 'UNITS',
      autoRequired: true,
      title: 'incidents.detail',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'incidents.event',
          disabled: false,
          href: '#/event-log'
        },
        {
          text: 'incidents.detail',
          disabled: true,
          href: '#/detail-incident'
        }
      ]
    }
  }
]